import { FC, memo, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button, Flex, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import { StyledSignature } from './styled';

interface IProps {
  onEnd: (image: string) => void;
  onClear: () => void;
}

const Signature: FC<IProps> = ({ onClear, onEnd }) => {
  const { t } = useTranslation();
  const signatureRef = useRef<SignatureCanvas>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleEnd = () => {
    if (signatureRef.current) {
      const dataURL = signatureRef.current.toDataURL();

      onEnd(dataURL);
    }
  };

  const onClearClick = () => {
    onClear();
    signatureRef.current?.clear();
  };

  return (
    <Space direction="vertical" size={4} style={{ width: '100%' }}>
      <StyledSignature ref={containerRef}>
        <SignatureCanvas
          penColor="black"
          onEnd={handleEnd}
          ref={signatureRef}
          canvasProps={{
            className: 'sigCanvas',
            width: containerRef.current?.offsetWidth || 614,
            height: containerRef.current?.offsetHeight || 200
          }}
        />
      </StyledSignature>
      <Flex justify="end">
        <Button type="link" onClick={onClearClick} style={{ padding: 0 }}>
          {t('common.clear')}
        </Button>
      </Flex>
    </Space>
  );
};

export default memo(Signature);
